import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { GlobalService } from '@commoncore/services/global.service';
import { KEY_CODE } from '@commoncore/services/universal.service';
import { UploadQueueImpl } from '@mainrepo/app/core/implementation/UploadQueueImpl';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';


@Component({
  standalone:true,
  selector: 'app-duplicate-folder-popup',
  templateUrl: './duplicate-folder-popup.component.html',
  styleUrls: ['./duplicate-folder-popup.component.scss'],
  imports:[DependenciesModule]
})
export class DuplicateFolderPopupComponent implements OnInit {
  @Input() currentFolder:any;
  @Input() currentFolderIndex:any;
  @Input() showDuplicateFolderPopUp:boolean;
  @Output() closePopUp = new EventEmitter();
  @Output() uploadFolder = new EventEmitter();
  universalService:any;
  selectedButton:string = "upload";
  selectedOption:string = "createNew";
  uploadQueueImplRef: any;

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.close();
    }else if (event.key === "Enter" && this.selectedButton == "upload"){
      this.upload();
    }else if (event.key === "Enter" && this.selectedButton == "cancel"){
      this.close();
    }
    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      $('#btn-duplicate-folder-cancel').addClass('no-bg');
      $('#btn-duplicate-folder-upload').removeClass('no-bg');
      this.selectedButton = "upload"
    }
    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      $('#btn-duplicate-folder-cancel').removeClass('no-bg');
      $('#btn-duplicate-folder-upload').addClass('no-bg');
      this.selectedButton = "cancel"
    }
  }

  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService);
   }

  ngOnInit(): void {
    setTimeout(() => {
      console.log("currentFolderIndex::",this.currentFolderIndex)
      $('#btn-duplicate-folder-upload').removeClass('no-bg');
      $('#btn-duplicate-folder-cancel').addClass('no-bg');
    }, 10);
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.uploadQueueImplRef = UploadQueueImpl.getInstance(this.globalService)

  }

  close(){
    this.closePopUp.emit();
  }

  upload(){
    this.uploadFolder.emit(this.selectedOption);
  }

  changeSelection(merge){
      this.selectedOption = merge;
  }


  







}
